module.exports = __webpack_public_path__ + "img/3.cbc8ee13.jpg";